import { gsap } from 'gsap';
import Headroom from 'headroom.js';
import { headerHeight, announcementBarHeight } from '../helpers';

if (!window.dAgency) window.dAgency = {};

$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0)
    return false;

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
  $('#CartPopup').css('top', headerHeight() + 'px');

  $(window).on('resize', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ====================== HeadrooomJS ====================== */
  const header = document.querySelector('header.site-header');
  if (header) {
    const options = {
      tolerance: {
        up: 20,
        down: 20
      },
      onPin: function () {
        if (this.elem) {
          const $announcement = $(this.elem).find('#shopify-section-announcement-bar');
          if ($announcement.length > 0) {

            let announcementPinned = true;
            if (typeof ($announcement.find('.announcement-bar').attr('data-pinned')) == 'undefined') {
              announcementPinned = false;
              $announcement.slideDown(250);
            }

            const $searchPopup = $header.find('.header__search-popup');
            if ($searchPopup.length > 0) {
              if (announcementPinned) {
                $searchPopup.css('top', 'calc(' + headerHeight() + 'px' + announcementBarHeight() + 'px)');
              } else {
                $searchPopup.css('top', headerHeight() + 'px');
              }
            }

            if ($desktopMenu.length > 0 && $desktopMenu.hasClass('header__desktop-menu--drawer')) {
              $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
                $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
              });
            }
          }
        }
      },
      onUnpin: function () {
        if (this.elem) {
          const $announcement = $(this.elem).find('#shopify-section-announcement-bar');
          if ($announcement.length > 0) {

            let announcementPinned = true;
            if (typeof ($announcement.find('.announcement-bar').attr('data-pinned')) == 'undefined') {
              announcementPinned = false;
              $announcement.slideUp(250);
            }

            const $searchPopup = $header.find('.header__search-popup');
            if ($searchPopup.length > 0) {
              if (announcementPinned) {
                $searchPopup.css('top', 'calc(' + headerHeight() + 'px' + announcementBarHeight() + 'px)');
              } else {
                $searchPopup.css('top', headerHeight() + 'px');
              }
            }

            if ($desktopMenu.length > 0 && $desktopMenu.hasClass('header__desktop-menu--drawer')) {
              $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
                $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
              });
            }
          }
        }
      }
    };

    const headroom = new Headroom(header, options);
    headroom.init();
  }

  /* ======================== Header ======================== */
  if ($header.hasClass('header__transparent')) {
    if ($(window).scrollTop() === 0) {
      $header.addClass('apply-transparency');
    } else {
      $header.removeClass('apply-transparency');
    }

    $(window).on('scroll', function () {
      if ($(window).scrollTop() === 0) {
        $header.addClass('apply-transparency');

        if ($('.header__desktop-menu--dropdown__dropdown-wrapper.open').length && !$header.hasClass('backdrop__blur')) {
          $header.addClass('backdrop__blur');
        }
      } else {
        $header.removeClass('apply-transparency');
      }
    });
  }

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $('.header__mobile-menu');
  if ($mobileMenu.length > 0) {

    $mobileMenu.find('[data-link-opener]').on('click', function (e) {
      if (e.target.getAttribute('href')) return;

      const drawerAttribute = $(this).data('link-opener');
      const $drawer = $(this).parent().find('[data-level="' + drawerAttribute + '"]');
      if ($drawer.length > 0) {
        $drawer.addClass('open');
      }
    });

    $mobileMenu.find('[data-close-level]').on('click', function () {
      $(this).parent().removeClass('open');
    });

    $header.find('.header__burger-icon').on('click', function () {
      if ($header.hasClass('apply-transparency')) {
        $mobileMenu.addClass('apply-transparency');
      }
      $mobileMenu.addClass('open');
      $('html').css('overflow-y', 'hidden');
      $header.css('opacity', 0);
    });

    $mobileMenu.find('.header__mobile--close').each(function () {
      $(this).on('click', function () {
        $mobileMenu.removeClass('open');
        $mobileMenu.removeClass('apply-transparency');
        $('html').css('overflow-y', '');
        $header.css('opacity', 1);
      });
    });

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css('transform', 'translate3d(0, 0, 0)');
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on('click', function () {
      const $menu = $(this).closest('.header__mobile-menu__level');
      $menu.css('transform', '');
    });
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  if ($desktopMenu.length > 0) {
    if ($desktopMenu.hasClass('header__desktop-menu--dropdown')) {
      const $dropdownInlineElements = $desktopMenu.find('.header__desktop-menu--dropdown__inline-elements__link');
      $dropdownInlineElements.each(function () {
        if ($desktopMenu.hasClass('header__desktop-menu--dropdown--alternative') && $(this).find('.header__desktop-menu--dropdown__navigation__element').length <= 0) return;

        $(this).on('click', function () {
          let activeImg = $(this).find('.header__desktop-menu--dropdown__navigation__media figure.active');
          if (activeImg.length && $(activeImg).attr('id') != 'undefined' && $(activeImg).attr('id') != $(this).attr('id')) {
            $(activeImg).removeClass('active');
            $(`figure#${$(this).attr('id')}`).addClass('active');
          }

          if ($('.header__desktop-menu--dropdown__dropdown-wrapper.open').length) {
            $('.header__desktop-menu--dropdown__dropdown-wrapper.open').removeClass('open');
          }

          $(this).find('.header__desktop-menu--dropdown__dropdown-wrapper').addClass('open');

          if ($header.hasClass('apply-transparency')) {
            $header.addClass('backdrop__blur');
          }
        });

        $(this).find('.header__desktop-menu--dropdown__dropdown-wrapper').on('mouseleave', function () {
          $(this).removeClass('open');
          $($header).removeClass('backdrop__blur');
        });
      });


      $desktopMenu.find('.header__desktop-menu--dropdown__navigation').each(function () {
        const $mediaContainer = $(this).find('.header__desktop-menu--dropdown__navigation__media');
        const $titleWithImages = $(this).find('[data-image-src]');

        $titleWithImages.on('mouseenter', function () {
          const imgSrc = $(this).data('image-src');
          const $img = $mediaContainer.find('[srcset*="' + imgSrc + '"]');

          $mediaContainer.find('figure.active').removeClass('active');
          $img.closest('figure').addClass('active');
        });

        $($mediaContainer).on('click', function (e) {
          e.stopPropagation();
        })
      });
    }
  }

  /* ==================== Desktop Search PopUp ==================== */
  const $deskSearchBar = $header.find('.header__search-popup');
  if ($deskSearchBar.length > 0) {
    $deskSearchBar.css('top', headerHeight() + 'px');

    const $iconSearch = $header.find('.header__right__element.search');
    if ($iconSearch.length > 0 && $(window).outerWidth() > 1024) {
      $iconSearch.on('click', function (e) {
        e.preventDefault();
        $deskSearchBar.toggleClass('open');

        if ($deskSearchBar.hasClass('open')) {
          $header.removeClass('apply-transparency');
          $deskSearchBar.find('form input[type="text"]').trigger('focus');
        } else {
          if ($(window).scrollTop() === 0) {
            $header.addClass('apply-transparency');
          }
        }
      });
    }

    $(window).on('resize', function () {
      if ($(window).outerWidth() <= 1024) {
        $deskSearchBar.removeClass('open');

        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');

        } else {
          $header.removeClass('apply-transparency');
        }
      } else {
        $deskSearchBar.css('top', headerHeight() + 'px');
      }
    });

    const $closeIcon = $deskSearchBar.find('.header__search-popup__close-icon');
    if ($closeIcon.length > 0) {
      $closeIcon.on('click', function () {
        $deskSearchBar.removeClass('open');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
      });
    }
  }
});
